import { Children } from 'react';
import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '../../../theme';
import { Icon } from '../../display/Icon';
const Styles = labelStyles('Breadcrumbs', {
    root: css `
    color: ${Colors.neutral800};
    &[data-size='large'] {
      ${Typography.paragraph1ShortSemibold};
    }
    &[data-size='small'] {
      ${Typography.smallPrint1Semibold};
    }
  `,
    list: css `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 2px 0px;
  `,
    item: css `
    display: flex;
    align-items: inherit;
    gap: inherit;
  `,
});
export const Breadcrumbs = ({ children, size = 'large' }) => {
    const iconSize = {
        small: 20,
        large: 24,
    }[size];
    const items = Children.toArray(children)
        .filter(Boolean)
        .map((link, i, links) => {
        const icon = i !== links.length - 1 && (isolateComponent("span", { "aria-hidden": "true" },
            isolateComponent(Icon, { css: Styles.icon, isBlock: true, color: "neutral400", name: "arrowSmallRight", size: iconSize })));
        return (isolateComponent("li", { css: Styles.item, key: i },
            link,
            icon));
    });
    return (isolateComponent("div", { css: Styles.root, "data-size": size },
        isolateComponent("ol", { css: Styles.list }, items)));
};
//# sourceMappingURL=Breadcrumbs.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
